import apiClient from './apiClient';

export async function listProducts(params = {}) {
  const { data } = await apiClient.get('/api/products', { params });
  return data;
}

export async function createProduct(payload) {
  const { data } = await apiClient.post('/api/admin/product', payload);
  return data;
}

export async function updateProduct(id, payload) {
  const { data } = await apiClient.put(`/api/admin/product/${id}`, payload);
  return data;
}

export async function deleteProduct(id) {
  const { data } = await apiClient.delete(`/api/admin/product/${id}`);
  return data;
}
